// Libraries
import {
  NgModule,
  ModuleWithProviders
} from '@angular/core';
import {
  HTTP_INTERCEPTORS
} from '@angular/common/http';

// Interceptors
import { MockupInterceptor } from './mockup.interceptor';

// Models
import {
  MockupConfig,
  MOCKUP_CONFIG
} from './interfaces/mockup-config.interface';

/**
 * Define mockup module
 *
 * @author Lautaro Klein <lautaro.klein@woopasoft.com>
 * @export
 */
@NgModule({
  imports: [
  ]
})
export class MockupModule {
  public static forRoot(config: MockupConfig): ModuleWithProviders {
    return {
      ngModule: MockupModule,
      providers: [
        {
          provide: MOCKUP_CONFIG,
          useValue: config
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MockupInterceptor,
          multi: true
        }
      ]
    };
  }
}
